import { NgInject } from '@df/ng/ng-inject';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NCategoryViewLayout } from './view/layout/category-view-layout.component';
import { Category as CoreCategory } from '@df/catalog/category/category';
import { ICategoryData } from '@df/catalog/category/category';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { CategoryResource } from '@df/catalog/category/category.resource';
import { NCmsCategoryHeaderBlock } from './view/header/cms-category-header-block.component';

declare module '@df/catalog/category/category' {
    interface ICategoryDataV3 {
        image: string;
        text_color?: string;
        mobile_image?: string;
        seo_header?: string;
        seo_description?: string;
    }
}

export class Category<T extends ICategoryData = ICategoryData> extends CoreCategory<T> {
    /**
     * Load cms block servoce
     */
    @NgInject(ICmsBlockResource)
    private iCmsBlockResource!: ICmsBlockResource;

    protected override addDependenciesToLoader(params: TLoadDependeciesParams): void {
        super.addDependenciesToLoader(params);

        if (this.verbosity > 2) {
            params.loader.add(
                this.iCmsBlockResource.retrieve(
                    {
                        bareUrl: NCategoryViewLayout.BLOCK_ID,
                        variant: this.lpLayoutVariant
                    },
                    undefined
                )
            );
            params.loader.add(
                this.iCmsBlockResource.retrieve({ bareUrl: NCmsCategoryHeaderBlock.BLOCK_ID, variant: this.categoryHeaderVariant }, params)
            );
        }
    }

    /**
     * Category page layout variant
     */
    get lpLayoutVariant(): string {
        return this.data?.id + '';
    }

    get categoryHeaderVariant(): string {
        return this.data?.id + this.name;
    }
}

CategoryResource.instance = Category;
